import { render, staticRenderFns } from "./CommentRenderer.vue?vue&type=template&id=43eda9a1"
import script from "./CommentRenderer.vue?vue&type=script&lang=js"
export * from "./CommentRenderer.vue?vue&type=script&lang=js"
import style0 from "./CommentRenderer.vue?vue&type=style&index=0&id=43eda9a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports